import React from "react";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import info from "Assets/Icons/info.svg";

const InfoBubble = ({ message, title }) => {
  const infoMessage = <div style={{ fontSize: "14px" }}>{message}</div>;
  const infoPopover = (
    <Popover>
      <Popover.Body>{infoMessage}</Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      rootClose
      overlay={infoPopover}
    >
      <Button variant="Link" className="info-icon">
        <img className="top-menu-icon" alt="Info" src={info} />
      </Button>
    </OverlayTrigger>
  );
};

export default InfoBubble;
